/**
 * Estimates token count using a word-based heuristic.
 * Same approach used in supabase/functions/parse-document/index.ts.
 */
export function estimateTokens(text: string): number {
  return Math.round(text.split(/\s+/).filter(Boolean).length * 1.3);
}
